<template>
  <div class="container examRanking">
    <div class="TopThree">
      <!-- <p>本次考试参加时间：2020.01.01 - 2020.04.01</p> -->
      <div class="TopThree_item">
        <div class="TopThree_list">
          <div class="TopThree_username" v-if="ranking.length >= 2">
            <div>
              <i class="iconfont iconhuangguan"></i>
              <span>{{ranking[1].membername.length > 4 ? ranking[1].membername.substr(0,1) + '**' + ranking[1].membername.substr(-2,2) : ranking[1].membername}}</span>
            </div>
          </div>
          <div class="TopThree_score">
            <img src="../../../assets/images/no2.png" alt="">
            <div class="score_item" v-if="ranking.length >= 2">
              <h3>{{ranking[1].highestscore}}分</h3>
              <span>{{ranking[1].dtcs}}次，{{ranking[1].highestscoretimes}}秒</span>
            </div>
          </div>
        </div>
        <div class="TopThree_list">
          <div class="TopThree_username" v-if="ranking.length >= 1">
            <div>
              <i class="iconfont iconhuangguan"></i>
              <span>{{ranking[0].membername.length > 4 ? ranking[0].membername.substr(0,1) + '**' + ranking[0].membername.substr(-2,2) : ranking[0].membername}}</span>
            </div>
          </div>
          <div class="TopThree_score">
            <img src="../../../assets/images/no1.png" alt="">
            <div class="score_item" v-if="ranking.length >= 1">
              <h3>{{ranking[0].highestscore}}分</h3>
              <span>{{ranking[0].dtcs}}次，{{ranking[0].highestscoretimes}}秒</span>
            </div>
          </div>
        </div>
        <div class="TopThree_list">
          <div class="TopThree_username" v-if="ranking.length >= 3">
            <div>
              <i class="iconfont iconhuangguan"></i>
              <span>{{ranking[2].membername.length > 3 ? ranking[2].membername.substr(0,1) + '**' + ranking[2].membername.substr(-2,2) : ranking[2].membername}}</span>
            </div>
          </div>
          <div class="TopThree_score">
            <img src="../../../assets/images/no3.png" alt="">
            <div class="score_item" v-if="ranking.length >= 3">
              <h3>{{ranking[2].highestscore}}分</h3>
              <span>{{ranking[2].dtcs}}次，{{ranking[2].highestscoretimes}}秒</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ranking_table">
      <div class="ranking_t_tr ranking_t_header">
        <span>名次</span>
        <span>用户名</span>
        <span>答题次数</span>
        <span>最高成绩</span>
        <span>答题用时</span>
      </div>
      <div class="ranking_t_item" v-if="ranking.length > 3">
        <div class="ranking_t_tr" v-for="(rank, index) in ranking.slice(3)" :key="index">
          <span>{{index + 4}}</span>
          <span>{{rank.membername.length > 4 ? rank.membername.substr(0,1) + '**' + rank.membername.substr(-2,2) : rank.membername}}</span>
          <span>{{rank.dtcs}}次</span>
          <span>{{rank.highestscore}}分</span>
          <span>{{rank.highestscoretimes}}秒</span>
        </div>
      </div>
    </div>
    <div class="my_ranking">
      <div class="my_r_item">
        <div class="max_score">您的最高成绩：<span>{{score}}</span><span>分</span></div>
        <div class="ranking">排名：<span>{{rank > 0 ? '第'+ rank +'名' : '未上榜'}}</span></div>
        <button @click="$router.push('/exam')">继续挑战</button>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '../../../interface/api'
  export default {
    name: 'examRanking',
    data () {
      return {
        score: '',
        rank: 0,
        ranking: [],
      }
    },
    created () {
      this.$toast.allowMultiple();
      const load = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true
      })
      this.$fetch.get(API.EXAMRECORDLIST, {
        recordid: this.$route.query.id
      }).then(response => {
        // console.log(response)
        if (response.status !== 200) {
          var message = response.message ? response.message : '成绩排行榜获取失败，请刷新！'
          this.$toast.fail(message)
          return
        }
        this.score = response.data.highestscore
        this.rank = response.data.rank
        this.ranking = response.data.examRecordList
        load.clear()
      }).catch(error => {
        console.log()
        load.clear()
      })
    },
    methods: {
    }
  }
</script>

<style lang="stylus">
</style>